export enum IntraOralCameraChartFields {
  round1First = 'round1First',
  round1Second = 'round1Second',
  round1Third = 'round1Third',
  round2First = 'round2First',
  round2Second = 'round2Second',
  round2Third = 'round2Third',
}

export const IntraOralCameraChartFormDefaultValues = {
  [IntraOralCameraChartFields.round1First]: '',
  [IntraOralCameraChartFields.round1Second]: '',
  [IntraOralCameraChartFields.round1Third]: '',
  [IntraOralCameraChartFields.round2First]: '',
  [IntraOralCameraChartFields.round2Second]: '',
  [IntraOralCameraChartFields.round2Third]: '',
};

export const AttachmentFilesDefaultValues = {
  0: null,
  1: null,
  2: null,
  3: null,
  4: null,
  5: null,
};
